import ReservationsScreen from './ReservationsScreen';

export default ReservationsScreen;
